module.exports = __webpack_public_path__ + "img/depmap_svg_V68.bf5ecceb.svg";